import React from "react";
import { SvgIcons } from "../../../SharedComponents/SvgIcons/SvgIcons";
import styles from "./FetchingPill.module.css";

/**
 * The small "Fetching…" pill that sits beside a section title while its data is
 * on the way (Figma 553:2919, the Mentor section).
 */
const FetchingPill = () => (
  <span className={styles.pill} role="status">
    <SvgIcons name="loading_fill" className={styles.spinner} width="16" height="16" />
    Fetching…
  </span>
);

export default FetchingPill;
